import script from "./NewRegional.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRegional.vue?vue&type=script&setup=true&lang=js"

import "./NewRegional.vue?vue&type=style&index=0&id=104e0f41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104e0f41"]])

export default __exports__